import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

import PersonalPanel from './PersonalPanel';
import { BaseCard } from '../../../components/wizard';

class PersonalCard extends Component<any, any> {
  static propTypes: any;
  static defaultProps: any;

  render = () => {
    const { record = {}, data = {}, extras, setItem, ...extraProps } = this.props;
    const formdata = data.data || {};
    return (
      <Box>
        <BaseCard
          cardid={'PERSONAL'}
          cardname={'Personal'}
          cardtitle={'Personal Details'}
          instruction={'Capture member identity and origin information.'}
          step={2}
          buttons={['START', 'CANCEL', 'PREV', 'NEXT', 'GUIDE']}
          {...extraProps}
        >
          <PersonalPanel
            data={data}
            record={{ ...record, ...formdata }}
            extras={extras}
            setItem={setItem}
          />
        </BaseCard>
      </Box>
    );
  };
}

PersonalCard.propTypes = {
  classes: PropTypes.object,
};

export default PersonalCard;
